import React, { Component } from 'react';
import Formulario from './FormSeleccionarPais';
import { Redirect } from 'react-router-dom';

class SeleccionarPais extends Component{

    componentDidMount = () => {
        const { paisList, periodosList } = this.props;
        paisList();
        periodosList();
    }
    render(){
        const { pais, periodoL } = this.props;
        let ruta = window.location.href;
        let id_emp = ruta.split('/');
        return(
            pais.length >= 2 ? (
                <Formulario
                    pais={pais}
                    periodoL={ periodoL }
                />
            ) : (
                <React.Fragment>
                    {
                        pais.map((p) => 
                            <Redirect to={`/visitador_medico/${id_emp[5]}/visitador/${p.value}`} />
                        )
                    }
                </React.Fragment>
            )
        );
    } 
}

export default SeleccionarPais;